import Styles from './Sections.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { SectionProps } from './Types'
import { Text } from 'blaze-ui/Text/Text'
import { WizardButton } from '../WizardButton/WizardButton'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { TextGenerationType } from 'types'
import { Heart } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ListItemContainer } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItemContainer/ListItemContainer'
import { WizardListItem } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItem/ListItem'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { WizardButtonProps } from '../WizardButton/Types'

export const Brainstorm = (props: SectionProps) => {
  const { initialValues, ...otherProps } = props

  const { isMobile } = useResponsiveDesign()

  const ideasHeading = 'Brainstorm Content'
  const ideasSubheading = 'Quickly generate ideas you can easily turn into any type of content'

  const socialmediaIdeasProps = {
    channelKey: GenerationType.Brainstorm as TextGenerationType,
    initialValues: { ...initialValues, content_type: 'Social Media' },
    title: 'Social Media Ideas',
    icon: Heart,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Property_1_Social_Media_ordabg.png',
  }

  if (isMobile) {
    return (
      <div className={Styles.commonSectionContainer}>
        <div className={Styles.header}>
          <Heading level={5}>{ideasHeading}</Heading>
          <Text variant="placeholder" color="var(--dark-60>)">
            {ideasSubheading}
          </Text>
        </div>
        <ListItemContainer>
          <WizardListItem {...socialmediaIdeasProps} {...otherProps} />
          <WizardListItem {...otherProps} channelKey={ChannelType.BlogIdeas} />
          <WizardListItem {...otherProps} channelKey={ChannelType.NewsletterIdeas} />
          <WizardListItem {...otherProps} channelKey={GenerationType.ContentPlan} />
          <WizardListItem {...otherProps} channelKey={GenerationType.Brainstorm} />
        </ListItemContainer>
      </div>
    )
  }

  const commonProps: Partial<WizardButtonProps> = {
    size: 'lg',
    version: 2,
  }
  return (
    <div className={Styles.toolsContainer}>
      <div className={Styles.group}>
        <div className={Styles.headingContainer}>
          <Heading level={3}>What do you want to brainstorm</Heading>
        </div>
        <div className={Styles.wizardGroup}>
          <WizardButton {...otherProps} {...commonProps} channelKey={GenerationType.Brainstorm} title="Content Ideas" />
          <WizardButton {...otherProps} {...commonProps} channelKey={GenerationType.ContentPlan} title="Content Plan" />
          <WizardButton {...otherProps} {...commonProps} channelKey={ChannelType.BlogIdeas} />
          <WizardButton {...otherProps} {...commonProps} channelKey={ChannelType.NewsletterIdeas} />
          <WizardButton
            {...socialmediaIdeasProps}
            {...otherProps}
            {...commonProps}
            image="https://res.cloudinary.com/almanac/image/upload/v1737151943/blaze_assets/create_new_v3/v2_card_images/social_media_ideas_mnazue.png"
          />
        </div>
      </div>
    </div>
  )
}
